export const getLocalDateTimeString = (dateTime) => {
    // purpose of this is to prevent the 4 hour time difference from causing ship date to unintentionally be set to the next day if local time is 8pm or later
    const date = dateTime ? new Date(dateTime) : new Date();
    const offset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
    const localIsoTime = new Date(date.getTime() - offset).toISOString();
    return localIsoTime;
}
